import { render } from "./ContactsList.vue?vue&type=template&id=6b9c5e8e&ts=true"
import script from "./ContactsList.vue?vue&type=script&lang=ts"
export * from "./ContactsList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__